import { StyleSheet } from '../../../../utils/style/types';

const styles: StyleSheet = {
  avatarBoxMobile: {
    display: {
      mobile: 'flex',
      desktop: 'none',
    },
    margin: {
      desktop: '0 auto 12px auto',
      mobile: '0 auto 24px auto',
    },
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarBoxDesktop: {
    display: {
      mobile: 'none',
      desktop: 'flex',
    },
    margin: {
      desktop: '0 auto 12px auto',
      mobile: '0 auto 24px auto',
    },
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileWrapper: {
    py: {
      desktop: 8, mobile: 3.5,
    },
    minHeight: {
      desktop: 'calc(100vh - 298px)',
    },
  },
  profileCard: {
    border: 'none',
    boxShadow: 'none',
    margin: '0 auto',
    padding: '0',
  },
  profileSkeleton: {
    margin: '0 auto',
    height: '44px',
    width: '100%',
  },
};

export default styles;
